import React from "react";

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, errorInfo) {
		console.error("Error caught by boundary:", error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="min-h-screen flex items-center justify-center bg-ghost-white p-4">
					<div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
						<div className="mb-4">
							<svg
								className="w-16 h-16 mx-auto text-red"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24">
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
								/>
							</svg>
						</div>
						<h1 className="text-2xl font-bold text-dark mb-2">
							Oops! Something went wrong
						</h1>
						<p className="text-muted mb-6">
							We're sorry for the inconvenience. Please try refreshing the page.
						</p>
						<button
							onClick={() => window.location.reload()}
							className="bg-primary hover:bg-primary-hover text-white font-semibold py-3 px-6 rounded-md transition duration-300">
							Refresh Page
						</button>
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
